import { Controller } from '@hotwired/stimulus'

const SHIMMER_SELECTOR = '.skeleton-shimmer'

// Reveals every image of the group at once: as long as one request is pending the
// shimmer keeps running everywhere, otherwise the cards would fill in one by one.
export default class ImageLoaderController extends Controller {
  static targets = ['image']

  // An already cached image finished loading before Stimulus connected: its load
  // event is gone, so the action will never fire.
  imageTargetConnected() {
    this.#revealWhenAllComplete({instantly: true})
  }

  markLoaded() {
    this.#revealWhenAllComplete({instantly: false})
  }

  // `complete` is true as soon as the request is over, whether it succeeded or not.
  #revealWhenAllComplete({instantly}) {
    if (!this.imageTargets.every((image) => image.complete)) return

    this.imageTargets.forEach((image) => {
      const container = image.closest(SHIMMER_SELECTOR)

      if (!container) return

      if (instantly) container.classList.add('skeleton-no-transition')

      container.classList.add('skeleton-loaded')
    })
  }
}
